module.exports = __webpack_public_path__ + "static/media/mo1.638cfe12.jpg";